import React, { useEffect } from "react";
import NoDataFound from "../../common/NoDataFound";

import { loadStyles } from "../../../utils/cssLoader";
import RaceCards from "../../horse-racing/RaceCards";

const HorseRacingLeagueMatches = ({
    data,
    difference,
    loadCSS,
    dataClient,
    websiteBaseUrl,
    dataPath = "horse-racing",
    type = "horse-racing",
    sport = "horse-racing",
    dictionary = {},
}) => {

    useEffect(() => {
        if (loadCSS === "true") {
            loadStyles("horse-racing");
        }
    }, [loadCSS]);

    return (
        <div className="golf_listing">
            {data?.length ? (
                <RaceCards data={data} sport={sport} dataClient={dataClient} dataPath={dataPath} websiteBaseUrl={websiteBaseUrl} />
            ) : (
                <NoDataFound text={type === true ? 'There are no live games currently in progress' : 'No matches found'} />
            )}
        </div>
    );
};

export default HorseRacingLeagueMatches;